module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "id": "_Слой_2",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 85 85"
    }
  }, [_c('g', {
    attrs: {
      "id": "_Слой_1-2"
    }
  }, [_c('g', [_c('circle', {
    staticClass: "cls-2",
    attrs: {
      "cx": "42.5",
      "cy": "42.5",
      "r": "42.5"
    }
  }), _c('g', [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M27.98,33.25l3.69,1.74v5.84c0,.32,.18,.6,.46,.75l10,5c.12,.06,.24,.09,.37,.09s.26-.03,.37-.09l10-5c.28-.14,.46-.43,.46-.75v-5.84l2.5-1.18v5.93l-1.53,2.29c-.26,.38-.15,.9,.23,1.16,.14,.1,.3,.14,.46,.14,.27,0,.53-.13,.69-.37l.97-1.46,.97,1.46c.16,.24,.42,.37,.69,.37,.16,0,.32-.04,.46-.14,.38-.26,.49-.77,.23-1.16l-1.53-2.29v-7.25c0-.1-.02-.2-.06-.29,0-.03-.02-.05-.03-.08-.03-.07-.07-.13-.12-.18-.02-.02-.03-.04-.04-.05-.06-.06-.14-.11-.22-.15l-14.17-6.67c-.23-.11-.48-.11-.71,0l-14.17,6.67c-.29,.14-.48,.43-.48,.75s.19,.62,.48,.75Zm23.69,7.06l-9.17,4.58-9.17-4.58v-4.54l8.33,3.92v1.97c0,.46,.37,.83,.83,.83s.83-.37,.83-.83v-1.97l8.33-3.92v4.54Zm-9.17-13.56l10.44,4.91h-9.61v-.83c0-.46-.37-.83-.83-.83s-.83,.37-.83,.83v3.33c0,.46,.37,.83,.83,.83s.83-.37,.83-.83v-.83h9.61l-.79,.37s0,0,0,0l-9.65,4.54-12.21-5.75,12.21-5.75Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M64.17,18.33H20.83c-1.84,0-3.33,1.5-3.33,3.33v31.66c0,1.84,1.5,3.33,3.33,3.33h16.63c-.2,3.3-1.57,5-4.13,5h-1.67c-1.38,0-2.5,1.12-2.5,2.5s1.12,2.5,2.5,2.5h21.67c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5h-1.67c-2.55,0-3.93-1.7-4.13-5h16.63c1.84,0,3.33-1.5,3.33-3.33V21.67c0-1.84-1.5-3.33-3.33-3.33Zm-45,3.33c0-.92,.75-1.67,1.67-1.67h43.33c.92,0,1.67,.75,1.67,1.67v26.67h-1.67V22.5c0-.46-.37-.83-.83-.83H21.67c-.46,0-.83,.37-.83,.83v25.83h-1.67V21.67Zm43.33,26.67H22.5V23.33H62.5v25Zm-8.33,15.83c0,.46-.37,.83-.83,.83H31.67c-.46,0-.83-.37-.83-.83s.37-.83,.83-.83h21.67c.46,0,.83,.37,.83,.83Zm-6.56-2.5h-10.22c1.03-1.14,1.63-2.83,1.75-5h6.71c.12,2.17,.72,3.86,1.75,5Zm18.23-8.33c0,.92-.75,1.67-1.67,1.67H20.83c-.92,0-1.67-.75-1.67-1.67v-3.33h46.67v3.33Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M45,51.67h-5c-.46,0-.83,.37-.83,.83s.37,.83,.83,.83h5c.46,0,.83-.37,.83-.83s-.37-.83-.83-.83Z"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7646d0fb","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/dashboard/obrazovatelProgramm.vue
// module id = 80288316ec0d1e547364
// module chunks = 89